<template>
	<el-dialog :visible.sync="dialogShow" :close-on-click-modal="false" :append-to-body="true" custom-class="radius5" width="420px" class="pm-archive">
		<div slot="title" class="text-warning font-md">
			<i class="el-icon-warning"></i>
			<span class="ml-xs text-bold">归档项目</span>
		</div>
		<div class="flex column">
			<span>
				<span>项目</span>
				<span class="text-warning">【{{ title }}】</span>
				<span>归档后，项目及包含的所有信息将会被转移到【已归档项目】内，归档项目将：</span>
			</span>
			<div class="flex column mt">
				<ul class="warning-info">
					<li>不可编辑</li>
					<li>不被统计信息和数据</li>
					<li>不可更改项目成员</li>
					<li>不再通知提醒</li>
				</ul>
			</div>
		</div>
		<div slot="footer" class="flex-center">
			<el-button size="small" @click="dialogShow = false">取消</el-button>
			<el-button size="small" type="primary" @click="submit">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		}
	},

	data () {
		return {
			moreShow: true
		}
	},

	computed: {
		dialogShow: {
			get () {
				return this.show
			},
			set (val) {
				this.$emit('update:show', val)
			}
		}
	},

	methods: {
		submit () {
			this.$emit('change')
			this.dialogShow = false
		}
	}
}
</script>

<style lang="scss">
.pm-archive {
	user-select: none;
	.el-dialog__body {
		padding: 10px 20px 20px;
		.warning-info {
			li {
				line-height: 22px;
				position: relative;
				margin-top: 4px;
				padding-left: 22px;
				&::before {
					content: '';
					position: absolute;
					left: 5px;
					top: 7px;
					width: 6px;
					height: 6px;
					border-radius: 50%;
					background: #e6a23c;
				}
			}
		}
	}
}
</style>